import {usePlantHierarchyQuery} from '@hproduce/suite-core'
import React from 'react'
import {Outlet} from 'react-router'

import {getHierarchyNodeById} from '../../Components/Base/header/PlantSelectButton/getHierarchyNodeNameById'
import {useHierarchyIdFromURL} from '../../Components/Base/header/PlantSelectButton/useHierarchyIdFromUrl'
import {useFeatureName} from '../features/useFeatureName'
import {InvalidSelectionPage} from '../InvalidSelectionPage'
import {useFeaturesMenu} from '../welcomeFlow/useFeaturesMenu'

import {findFeatureByName} from './findFeatureByName'
import {isHierarchyIndependentFeature} from './isHierarchyIndependentFeature'

export const FeatureScopeGuard: React.FC = () => {
  const {featuresMenu} = useFeaturesMenu()
  const featureName = useFeatureName()
  const [hierarchyId] = useHierarchyIdFromURL()
  const {data: plantHierarchy} = usePlantHierarchyQuery()

  if (!plantHierarchy || !hierarchyId) {
    throw new Error(
      'BUG: Plant hierarchy and hierarchyId should be loaded before rendering feature scope guard'
    )
  }

  const hierarchyNode = getHierarchyNodeById(plantHierarchy, hierarchyId)

  if (!hierarchyNode) {
    throw new Error(`BUG: Hierarchy node with id ${hierarchyId} should exist in plant hierarchy`)
  }

  if (!featuresMenu) {
    throw new Error('BUG: Features menu should be loaded before rendering feature routes')
  }
  const activeFeature = findFeatureByName(featuresMenu, featureName)

  if (!activeFeature) {
    throw new Error(`BUG: Feature ${featureName} should be validated by FeatureNameGuard`)
  }

  const isScopeValid =
    isHierarchyIndependentFeature(featureName) || activeFeature.scope.includes(hierarchyNode.type)

  if (isScopeValid) {
    return <Outlet />
  }

  return <InvalidSelectionPage />
}
